<template>
  <div
    id="page-bigTable"
    :class="className"
    v-loading="customLoading"
    :element-loading-text="loadingText"
  >
    <!-- 显示表格 -->
    <el-table
      style="width: 100%"
      ref="table"
      v-loading="loading"
      :size="size"
      :lazy="lazy"
      :load="load"
      :border="border"
      :row-key="rowKey"
      :data="tableData"
      :height="tableHeight"
      :tree-props="treeProps"
      :cell-style="cellStyle"
      :span-method="spanMethod"
      :row-class-name="rowClassName"
      :header-cell-style="headCellStyle"
      :element-loading-text="loadingText"
      @sort-change="sortChange"
      @cell-click="handleCellClick"
      @cell-mouse-enter = 'handleCellMouseEnter'
      @cell-mouse-leave = 'handleCellMouseLeave'
      @row-click="handleRowClick"
      @select-all="handleSelectionChange"
      @selection-change="handleSelectionChange"
      :data-size="data.length"
      v-loadmore="handelLoadmore"
    >
      <!-- 选择框 -->
      <el-table-column v-if="checkBox" :key="'selection'" type="selection" width="55" />
      <!-- 序号 -->
      <el-table-column
        v-if="tabIndex"
        :key="'index'"
        align="center"
        label="序号"
        :width="fieldList.length === 0 ? '' : 80"
        fixed
      >
        <template v-slot="scope">
          <span>{{ scope.$index + 1 + (pageRequest.pageNo - 1) * pageRequest.pageSize }}</span>
        </template>
      </el-table-column>
      <!-- 列内容 -->
      <el-table-column
        v-for="(item, index) in fieldList.filter(item => !item.hidden)"
        :key="index"
        :prop="item.props"
        :label="item.label"
        :fixed="item.fixed"
        :align="item.align || 'left'"
        :width="item.width"
        :sortable="item.sortable"
        :min-width="item.minWidth || '100'"
        :show-overflow-tooltip="item.overflow"
      >
        <!-- 自定义表头 -->
        <template v-if="item.header" v-slot:header="scope">
          <slot :name="item.props" :row="scope.row" :item="item" />
        </template>

        <template v-slot="scope">
          <!-- solt 自定义列-->
          <template v-if="item.type === 'slot'">
            <slot :name="'col-' + item.props" :row="scope.row" :rowIndex="scope.$index" />
          </template>
          <!-- 嵌套表格 -->
          <template v-else-if="item.children">
            <el-table-column
              v-for="(childItem, childIndex) in item.children"
              :key="childIndex"
              :prop="childItem.props"
              :label="childItem.label"
              align="center"
              :width="item.width"
              :min-width="item.minWidth || '85px'"
            />
          </template>
          <!-- 正常文本 -->
          <span v-else>{{scope.row[item.props]}}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="handle"
        key="handle"
        align="center"
        :fixed="handle.fixed"
        :label="handle.label"
        :width="handle.width"
      >
        <template v-slot="scope">
          <template v-for="(item, index) in handle.btList">
            <!-- 自定义操作类型 -->
            <slot v-if="item.slot" :name="'bt-' + item.event" :data="{item, row: scope.row}" />
            <!-- 操作按钮 -->
            <el-button
              v-if="!item.slot && item.show && (!item.ifRender || item.ifRender(scope.row))"
              :key="index"
              :size="item.size || 'mini'"
              :type="item.type"
              :icon="item.icon"
              :disabled="item.disabled"
              :loading="scope.row[item.loading]"
              @click="handleClick(item.event, scope.row)"
            >{{ item.label }}</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <template v-if="pager">
      <div v-show="!loading" class="pagination-container">
        <el-pagination
          background
          small
          layout="total, prev, pager, next, sizes, jumper"
          :current-page.sync="pageRequest.pageNo"
          :page-size="pageRequest.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <!-- @prev-click="pageIndexChange"
        @next-click="pageIndexChange"-->
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "PublicTable",
  props: {
    // 自定义类名
    className: {
      type: String,
    },
    // loading, 一种是外部盒子，一种是表格
    customLoading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "请稍等...",
    },
    border: {
      type: Boolean,
      default: true
    },
    // 是否懒加载子节点数据
    lazy: {
      type: Boolean,
      default: false,
    },
    // 加载子节点数据的函数，lazy 为 true 时生效，函数第二个参数包含了节点的层级信息
    load: {
      type: Function,
      default: () => {},
    },
    // 行数据的 Key，用来优化 Table 的渲染；
    rowKey: {
      type: String,
      default: "",
    },
    // 渲染嵌套数据的配置选项
    treeProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 表格尺寸
    size: {
      type: String,
      default: "small",
    },
    tableHeight: {
      type: [String, Number],
      default: null,
    },
    // 行的 className 的回调方法
    rowClassName: {
      type: [String, Function],
      default: "",
    },
    // 单元格 className 的回调方法
    cellStyle	: {
      type: [Object, Function],
      default: () => {},
    },
    headCellStyle: {
      type: [Object, Function],
      default: () => {},
    },
    // 合并行或列的计算方法
    spanMethod: {
      type: [Function],
      default: () => {}
    },
    // 刷新
    refresh: {
      type: Number,
    },
    // 是否显示序号
    tabIndex: {
      type: Boolean,
      default: false,
    },
    // 是否有选择框
    checkBox: {
      type: Boolean,
      default: false,
    },
    // 选中列表
    checkedList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 类型列表
    listTypeInfo: {
      type: Object,
    },
    // 表格字段配置
    fieldList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 操作栏配置
    handle: {
      type: Object,
      default: () => {},
    },
    // 是否分页
    pager: {
      type: Boolean,
      default: true,
    },
    // 重置当前页
    initCurpage: {
      type: Number,
    },
    // 查询条件
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 列表数据
    data: {
      type: [Array, Object],
    },
  },
  data() {
    return {
      currentStartIndex: 0,
      currentEndIndex: 20,
      // 列表相关
      pageRequest: {
        pageNo: 1, // 当前页
        pageSize: this.$store.getters.pageSize, // 每页条数
      },
      loading: false,
    };
  },
  computed: {
    tableData () {
      let datas = Array.isArray(this.data) ? this.data : this.data.list;
      return datas.filter((item, index) => {
        if (index < this.currentStartIndex) {
          return false;
        } else if (index > this.currentEndIndex) {
          return false;
        } else {
          return true;
        }
      });
    },
    total() {
      return Array.isArray(this.data) ? null : this.data.count;
    },
  },
  watch: {
    initCurpage() {
      this.pageRequest.pageNo = 1;
    },
  },
  methods: {
    handelLoadmore (currentStartIndex, currentEndIndex) {
      this.currentStartIndex = currentStartIndex;
      this.currentEndIndex = currentEndIndex;
    },
    findPage() {
      this.loading = true;
      const callback = () => {
        this.loading = false;
      };
      this.$emit("findPage", {
        pageRequest: this.pageRequest,
        callback,
      });
    },
    // 切换每页显示条数
    handleSizeChange(val) {
      const pageRequest = this.pageRequest;
      // 每页条数
      pageRequest.pageSize = val;
      // 每页条数切换，重置当前页
      // pageRequest.pageNo = 1;
      this.findPage();
    },
    // 鼠标移入
    handleCellMouseEnter(row, column, cell, event) {
      this.$emit('cellMouseEnter',row, column, cell, event)
    },
    handleCellMouseLeave(row, column, cell, event) {
      this.$emit('cellMouseLeave',row, column, cell, event)
    },
    // 点击对应页面跳转页
    handleCurrentChange(val) {
      // 当前页
      this.pageRequest.pageNo = val;
      this.findPage();
    },
    // 排序事件触发
    sortChange({ column, prop, order }) {
      this.$emit("sortChange", column, prop, order);
    },
    clearSort() {
      this.$refs.table.clearSort();
    },
    // 点击单元格
    handleCellClick(row, column, cell, event) {
      this.$emit("cellClick", row, column, cell, event);
    },
    // 点击行
    handleRowClick(row, column, event) {
      this.$emit("rowClick", row, column, event);
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    // 选中数据
    handleSelectionChange(rows) {
      this.$emit("handleEvent", rows);
    },
    // 获取已选中的行数据
    getCheckboxRecords() {
      return this.$refs.table.selection;
    },
  },
};
</script>

<style lang="less">
// 自定义表格相关
#page-bigTable {
  .el-table {
    th {
      background: #f6f8fa;
    }
  }
  th {
    font-size: 14px;
    color: #000;
    border-color: #e6e6e6;
  }
  td,
  th {
    .cell {
      line-height: 15px;
    }
  }
  .pagination-container {
    text-align: right;
    margin-top: 15px;
    .el-pagination {
      display: inline-block;
    }
    .el-input--mini .el-input__inner {
      height: 22px;
      line-height: 22px;
    }
    .el-pagination__jump {
      margin-left: 10px;
    }
    .pageBtn {
      height: 25px;
      padding: 2px 5px;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bigTable/index.vue